import { render, staticRenderFns } from "./PcCerts.vue?vue&type=template&id=9ffba7a0&"
import script from "./PcCerts.vue?vue&type=script&lang=js&"
export * from "./PcCerts.vue?vue&type=script&lang=js&"
import style0 from "./PcCerts.vue?vue&type=style&index=0&id=9ffba7a0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports